import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setKey, setDefaults, setLanguage, setRegion, fromAddress, fromLatLng, fromPlaceId, setLocationType, geocode, RequestType } from "react-geocode";

import LocationServiceStatusPrompt from "../pages/virtual-pt/Components/LocationServiceStatusPrompt";
import LocationServiceAnimation from "../pages/virtual-pt/Components/LocationServiceAnimation";

import { callSocket } from "../utils/socket";

function useVPTLocation({ location, vptStatus, SetVPTStatus, SetModalProperties, ShowModal, onClickCloseButton, AddUserLocation, SetLocation, CheckLocationEligibility }) {
    const platform = localStorage.getItem("indi-platform");
    const isUsingMobileApp = platform && (platform === "ios-app" || platform === "android-app");

    const navigate = useNavigate();

    const initVPT = () => {
        if (vptStatus == 1 || location != null) {
            navigate("/virtual-pt");
            ShowModal(false);
            onClickCloseButton();
        } else if (vptStatus == 0) {
            showVPTNotEligible();
        } else {
            ShowModal(false);
            showVPTLoading();

            if (isUsingMobileApp) {
                callSocket("/interact-native-component", { type: "location", requestType: platform === "android-app" ? 3 : 2 });
            } else {
                callWebLocationService();
            }
        }
    };

    const callWebLocationService = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const res = await axios({
                        method: "GET",
                        url: `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${position?.coords?.latitude}&lon=${position?.coords?.longitude}`,
                        // url: `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${36.674460}&lon=${-112.075763}`,
                    });

                    const location = {
                        address: {
                            country: res?.data?.address?.country || "",
                            city: res?.data?.address?.city || "",
                            region: res?.data?.address?.state || res?.data?.address?.region || "",
                            timezone: "",
                            postal_code: res?.data?.address?.postcode || "",
                        },
                        coordinates: {
                            longitude: position?.coords?.longitude,
                            latitude: position?.coords?.latitude,
                        },
                    };
                    AddUserLocation({
                        location: location,
                    });
                    // SetLocation(location);
                    CheckLocationEligibility(location?.address?.region, location);
                },
                (error) => {
                    showVPTLocationRequired();
                }
            );
        } else {
            ShowModal(false);
            showVPTLocationRequired();
        }
    };

    const showVPTLoading = () => {
        SetVPTStatus(null);
        SetModalProperties({
            isShow: true,
            height: "100%",
            className: "g-pink",
            showCloseButton: false,
            title: "",
            body: <LocationServiceAnimation />,
            actions: [],
        });
    };

    const showVPTNotEligible = () => {
        SetModalProperties({
            isShow: true,
            title: "",
            body: (
                <LocationServiceStatusPrompt
                    close={() => {
                        ShowModal(false);
                    }}
                    mainMessage="We Can't See You Now, But We'll Be There Soon!"
                    subMessage="We're Sorry! Unfortunately, you're currently not eligible for virtual physical therapy services."
                />
            ),
            actions: [],
            forceType: "popup",
        });
    };

    const showVPTLocationRequired = () => {
        SetModalProperties({
            isShow: true,
            title: "",
            body: (
                <LocationServiceStatusPrompt
                    close={() => {
                        ShowModal(false);
                    }}
                    mainMessage="Location is Required for PT Services"
                    subMessage={
                        <>
                            Please enable your location to proceed.&nbsp;
                            {!isUsingMobileApp && (
                                <a href="https://support.google.com/chrome/answer/142065?co=GENIE.Platform%3DDesktop&hl=en" target="_blank">
                                    Enable Location in Browser Settings.
                                </a>
                            )}
                        </>
                    }
                    type={isUsingMobileApp ? 1 : 0}
                />
            ),
            actions: [],
            forceType: "popup",
        });
    };

    useEffect(() => {
        if (vptStatus != null) {
            if (vptStatus == 1) {
                navigate("/virtual-pt");
                ShowModal(false);
            } else if (vptStatus == -1) {
                showVPTLocationRequired();
            } else if (vptStatus == 0) {
                showVPTNotEligible();
            }
        }
    }, [vptStatus]);

    return {
        initVPT,
        showVPTLoading,
        showVPTNotEligible,
        showVPTLocationRequired,
    };
}

export default useVPTLocation;
